import styled from 'styled-components';
export const AnchorLinkSpan = styled.span.attrs({
  className: 'spf-rce-link-span',
})`
  font-size: 0;
`;

export const AnchorLink = styled.a.attrs({
  className: 'spf-rce-link',
})`
  font-size: inherit;
  text-decoration: none;
  color: #0073ca;

  span {
    text-decoration: underline;
  }
`;
